import React from "react";
import Marty from "marty";
import Hero from "../components/Hero";
//import { Link } from "react-router";

const jobInfo = [
    {
        name: "Software engineering",
        title: "Software engineering",
        copy: "We own what we build from beginning to end and rapidly iterate, shipping code multiple times a day. We surround ourselves with people who jump at teaching opportunities. There’s no room for ego, and we’ve accumulated a group of curious engineers with complementary styles."
    },
    {
        name: "Hardware engineering",
        title: "Hardware engineering",
        copy: "Many of us have cut our teeth on consumer hardware products, but building an entirely different home WiFi model is a new challenge. We’ve attracted a team of accomplished networking engineers, and are looking for more experienced, versatile people to continue to build and scale eero."
    },
    {
        name: "Business operations",
        title: "Business operations",
        copy: "Problem solvers and strategic planners, we’re the people that oil the machine and keep things running smoothly. eero’s growing and changing rapidly, and our team develops solutions to make sure we’re doing so sustainably. Building a company’s infrastructure from scratch is no easy feat. We’re looking for innovative, driven team players to help us grow and run a successful company – we are a business, after all."
    },
    {
        name: "Marketing",
        title: "Marketing",
        copy: "As much as a product, we’re also building a brand. We're in debt to many companies that came before us, but also think we're doing something truly unique and new. We’re never satisfied until we find the perfect words to communicate our story. But we’re also not scared of the hard side of marketing – our goal is to analytically drive growth across all channels."
    },
    {
        name: "Design",
        title: "Design",
        copy: "Great design is in our DNA. It’s core to our product and our brand. We move readily between mediums and works well across teams. We’re creative, organized, meticulous. Our brand aesthetic is simple and sleek, but not sterile. A great product with great customer experience begins with great design."
    },
    {
        name: "Customer experience",
        title: "Customer experience",
        copy: "In an industry that’s (in)famous for terrible customer service, we’re different. We may be a small company but we’ve invested hugely in support. We’re committed to creating an incredible customer experience – helping customers with everything from purchasing to troubleshooting. Whatever the situation, our team’s job is making it right."
    },
    {
        name: "Manufacturing",
        title: "Manufacturing",
        copy: "With experience across aerospace, high-tech, and consumer products, we move quickly between strategic decisions and tactical deliverables. We're building a scalable supply chain, consistently delivering a high-quality product, and having some fun along the way."
    }
];

let Jobs = React.createClass({
    componentWillMount() {
        this.app.navActions.hideBuyButton();
        if (Marty.isBrowser) {
            document.title = "eero - Jobs";
        }
    },
    componentWillUnmount() {
        this.app.navActions.showBuyButton();
    },
    handleJobInfoClick(i) {
        this.setState({
            current: i,
            last: this.state.current
        });
    },
    render() {
        return (
            <section className="eo-view jobs">
                <Hero className="main-hero">
                    <h1>
                        Join us. Must love WiFi.
                    </h1>
                    <a href="https://boards.greenhouse.io/eero" target="_blank" className="eo-btn-outline white hover-blue">Open positions</a>
                </Hero>

                <div className="eo-padded-wrapper">
                    <section className="grid-10 parent eo-section eo-info-panel dark eo-centered elevated-technology">
                        <h2 className="standard">The company we keep</h2>

                        <p className="standard eo-info-panel-copy">We’re a small, passionate team that’s changing a broken industry. Think of us as David versus Goliath. We roll with the punches and think on our feet. We interact in-person, minimize meetings, and love to walk and talk. Collaboration and respect rank high and everyone agrees that no task is beneath them. We’re working hard, but enjoy doing it.</p>

                        <p className="standard eo-info-panel-copy">We’re obsessed with making our homes better and smarter. We’re blazing the trail for the future of home WiFi, and we sweat every detail. We have big plans, and it’s going to take a lot of determination to get there. Think you’re up to the challenge?</p>
                    </section>
                </div>
                <section className="grid-10 parent eo-section eo-centered eo-mosaic">
                    <div className="grid-10 mosaic-row">
                        <img className="img-1_1 mosaic-img" src="/public/img/jobs/mosaic/1_1.jpg"/>
                        <img className="img-1_2 mosaic-img" src="/public/img/jobs/mosaic/1_2.jpg"/>
                        <img className="img-1_3 mosaic-img hide-s" src="/public/img/jobs/mosaic/1_3.jpg"/>
                    </div>
                    <div className="grid-10 mosaic-row">
                        <img className="img-2_1 mosaic-img" src="/public/img/jobs/mosaic/2_1.jpg"/>
                        <img className="img-2_2 mosaic-img" src="/public/img/jobs/mosaic/2_2.jpg"/>
                        <img className="img-2_3 mosaic-img hide-s" src="/public/img/jobs/mosaic/2_3.jpg"/>
                    </div>
                </section>
                <div className="eo-padded-wrapper about-teams-wrapper hide-s">
                    <section className="grid-10 parent eo-section eo-centered hide-s about-teams">
                        <h2 className="standard">Our teams</h2>

                        <div className="grid-10 team-carousel">
                            <div className="grid-3 menu">
                                { jobInfo.map((group, i)=> {
                                    return (
                                        <h3 key={i} className={["team-carousel-button", (this.state.current === i ? "active" : "")].join(" ")}
                                            onClick={this.handleJobInfoClick.bind(null, i)}>{group.name}</h3>
                                    );
                                }) }
                            </div>
                            <div className="grid-7 content team-carousel-slide-wrap">
                                { jobInfo.map((group, i)=> {
                                    return (
                                        <div key={i} className={["team-carousel-slide", (this.state.current === i ? "in" : ""), (this.state.last === i ? "in-2" : "")].join(" ")}>
                                            <p className="slide-copy">{group.copy}</p>
                                        </div>
                                    );
                                }) }
                            </div>
                        </div>
                    </section>
                </div>
                <div className="eo-padded-wrapper job-openings">
                    <section className="grid-10 parent eo-section eo-centered jobs-board">
                        <div className="openings-img hide-s">
                            <img src="/public/img/jobs/img-jobs-openings.jpg"/>
                        </div>
                        <div className="openings-copy grid-5">
                            <h2>Convinced yet?</h2>
                            <p className="openings-text">
                                Want to be a part of our fast growing team? Head to our current openings to see where you might fit in. Apply online and we'll be in touch soon.
                            </p>
                            <a href="https://boards.greenhouse.io/eero" target="_blank" className="eo-btn-outline blue hover-blue">Current openings</a>
                        </div>
                    </section>
                </div>
                <div className="eo-padded-wrapper grid-10">
                    <section className="grid-10 parent eo-section eo-centered brass-tacks">
                        <p className="grid-10 hide-m hide-l hide-xl icon tack-icon eo-icon-tack"/>

                        <h2 className="standard grid-10">Brass tacks</h2>

                        <div className="brass-tack">
                            <span className="icon tack-icon eo-icon-heart hide-s"/>

                            <h3>Here's to you</h3>

                            <p>Full medical, dental, and vision coverage. Short-term disability, long-term disability and life insurance. Flexible time-off, commuter benefits and a great 401k. We want you to be your best self, at work and in life.</p>
                        </div>
                        <div className="brass-tack">
                            <span className="icon tack-icon eo-icon-lunch hide-s"/>

                            <h3>Such thing as a free lunch</h3>

                            <p>We have a full chef’s kitchen, and it’s always fully stocked. Cook your own lunch or snack the day away. Dinner’s on us.</p>
                        </div>
                        <div className="brass-tack">
                            <span className="icon tack-icon eo-icon-eero hide-s"/>

                            <h3>WiFi for the people</h3>

                            <p>What kind of hardware company would we be if we didn’t eat our own dog food? Every employee gets a free eero system for their home. You’ll have the coolest WiFi on the block.</p>
                        </div>
                    </section>
                </div>
                <div className="eo-padded-wrapper grid-10">
                    <Hero className="blog-hero grid-10 eo-cta half-hero">
                        <div className="content-wrap">
                            <h1 className="big-text eo-cta-header"><span className="big-text">A WELL<br/>CONNECTED<br/>BLOG</span></h1>
                            <a href="https://blog.eero.com" target="_blank" className="eo-btn-outline white hover-blue">Read more</a>
                        </div>
                    </Hero>
                </div>
            </section>
        );
    },
    getInitialState() {
        return {
            current: 0,
            last: 0
        };
    }
});

export default Marty.createContainer(Jobs, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/jobs/Handler.js
 **/